/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_ALLTRIMCLIPS, ALLTRIMCLIPS_RECEIVED , UPDATE_EDITOR_TRANSCRIPT_DATA} = constants.GetAllTrimClipsConstants;

export default {
  REQUEST_ALLTRIMCLIPS,
  ALLTRIMCLIPS_RECEIVED,
  UPDATE_EDITOR_TRANSCRIPT_DATA,

  requestGetAllTrimClips: payload => ({
    type: REQUEST_ALLTRIMCLIPS,
    payload
  }),
  GetAllTrimClipsReceived: () => ({
    type: ALLTRIMCLIPS_RECEIVED
  }),

  EditEditorTranscriptData : payload => ({
    type: UPDATE_EDITOR_TRANSCRIPT_DATA,
    payload
  }),
};
